













import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import * as d3 from '../../../../static/lib/d3.v4.min.js';
import LeftTreeI from '@root/src/dv-pure-render/tree-common-leaf/tree-common-leaf.js';
let LeftTree:any = LeftTreeI;

@Component({
    components: {}
})
export default class App extends Vue {
    @Prop({})
    userData: any;

    @Prop({})
    entityType: any;

    @Prop({})
    detailData: any;

    @Prop({})
    poiData: any;

    treeDom: any;
    leftTree: any;

    @Watch('userData')
    onUserData(userData: any, oldVal: any) {
        if (this.entityType !== 'user') {
            return void 0;
        }
        if (userData.LeftData) {
            let data = this.makeUserData(userData);
            this.draw('user', data);
        }
    }

    @Watch('poiData')
    onPoiData(poiData: any, oldVal: any) {
        if (this.entityType !== 'poi') {
            return void 0;
        }
        if (poiData.LeftData) {
            let data = this.makePoiData(poiData);
            this.draw('poi', data);
        }
    }

    makePoiData ({LeftData, RightData}) {
        let poiName = RightData['名称'];
        let treeObj = {name: poiName, children: []};
        // let mainChildren = treeObj.children;
        let dishArr = LeftData.filter(item => item.dishName !== null);
        dishArr = dishArr.slice(0, 6).map(dishItem => {
            return {
                name: dishItem.dishName,
                pos: dishItem.recommendCountReservoir,
                mid: dishItem.recommendAndMidCountReservoir - dishItem.recommendCountReservoir,
                reservoir: dishItem.recommendCountReservoir,
                children: (dishItem.tags && dishItem.tags.map(tagItem => {
                    return {
                        name: tagItem
                    }
                })).slice(0, 5) || []
            }
        });
        treeObj.children = dishArr;
        return treeObj;
    }

    makeUserData ({LeftData, RightData}) {
        let userName = RightData['美团用户昵称'] || RightData['点评用户昵称'];
        let treeObj: any = {name: userName, children: []};
        let mainChildren = treeObj.children;

        for (let key in LeftData) {
            let newKey = key.split(':')[0];
            let poiArr = LeftData[key];
            mainChildren.push({
                name: newKey,
                children: poiArr.map((poiItem) => {
                    return {
                        name: poiItem.poiName,
                        children: poiItem.tags.map((tagItem) => {
                            return {name: tagItem};
                        }).slice(0, 3)
                    }
                }).slice(0, 5)
            });
        }
        return treeObj;
    }

    draw (type, data) {
        this.leftTree = null;
        this.treeDom.innerHTML = '';

        this.leftTree = new LeftTree({dom: this.treeDom, type, data, d3,})
    }

    async mounted () {
        this.treeDom = this.$refs.leftTree as HTMLDivElement;
        this.$autoOn('poi-left-tree-animation', async () => {
            await this.leftTree.animation();
        });

        this.$autoOn('window-resize', () => {
            //  console.log('left-tree-resize');
            if (this.poiData.LeftData && this.entityType === 'poi') {
                // console.log('left-tree-resize');
                this.leftTree && this.leftTree.destroy();
                let data = this.makePoiData(this.poiData);
                this.draw('poi', data);
            }
            if (this.entityType === 'user' && this.userData.LeftData) {
                this.leftTree && this.leftTree.destroy();
                let data = this.makeUserData(this.userData);
                this.draw('user', data);
            }
        });

        this.$autoOn('action-script-stop', () => {
            this.leftTree && this.leftTree.stop();
        });

        this.$autoOn('action-script-start', () => {

        });
    }
}
